import { Skeleton } from "pepsico-ds";

const SkeletonList = ({ count = 1, height=15 }) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width:"100%" }}>
        {Array.from({ length: count }).map((_, index) => (
            <Skeleton 
              height={height+"px"} 
            />  
        ))}
      </div>
    );
  };

export { SkeletonList }